import type { MenteePastSessionRow } from './MenteePortalService';
import { formatModeLabel } from './menteeSessionsFormat';

type Props = {
    sessions: MenteePastSessionRow[];
    isLoading: boolean;
    loadError: string | null;
    onRate: (session: MenteePastSessionRow) => void;
};

const ReadOnlyStars = ({ value }: { value: number }) => (
    <span className="msess-stars" aria-label={`${value} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((star) => (
            <span key={star} className={star <= value ? 'is-filled' : 'is-empty'} aria-hidden="true">
                ★
            </span>
        ))}
    </span>
);

const MenteeSessionsPast = ({ sessions, isLoading, loadError, onRate }: Props) => {
    if (loadError) {
        return <p className="mreg-banner is-danger">{loadError}</p>;
    }
    if (isLoading) {
        return <p className="msess-empty">Loading past sessions…</p>;
    }
    if (sessions.length === 0) {
        return <p className="msess-empty">No past sessions yet. Completed 1:1s appear here after they are logged.</p>;
    }

    return (
        <div className="msess-list-card">
            <div className="row g-3">
                {sessions.map((row) => {
                    const rated = row.rating?.stars != null;
                    const stars = row.rating?.stars ?? 0;
                    return (
                        <div key={row.id} className="col-md-4 col-sm-6">
                            <div className="bg-success bg-opacity-10 border border-success border-opacity-25 rounded-3 p-3 font-13 text-black lh-base h-100">
                                <div className="msess-past-main">
                                    <p className="font-18 font-600 mb-2">
                                        {row.occurredAt || '—'}
                                        {row.durationMinutes != null ? ` · ${row.durationMinutes} min` : ''}
                                    </p>
                                    <div className="d-flex gap-2 align-items-center mb-2">
                                        <span className="badge bg-light text-dark font-13 font-500 py-2 px-3 shadow-sm rounded-pill">
                                            1:1
                                        </span>
                                        <span>{formatModeLabel(null)}</span>
                                    </div>
                                    {row.title ? <p className="font-16 text-dark mb-0">{row.title}</p> : null}
                                    <p className="font-16 text-dark mb-0">Recording: Available with built-in platform</p>
                                    {rated ? (
                                        <div className="msess-rated-block font-18">
                                            <ReadOnlyStars value={stars} />
                                            {row.rating?.feedbackText ? (
                                                <p className="font-16 text-dark mb-0 fst-italic">{row.rating.feedbackText}</p>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="d-flex gap-2 mt-2">
                                    {rated ? (
                                        <span className="bg-green text-white py-2 px-4 rounded-pill">Rated</span>
                                    ) : (
                                        <button type="button" className="btn btn-sm btn-outline-primary rounded-pill py-1 px-4" onClick={() => onRate(row)}>
                                            Rate
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MenteeSessionsPast;
